module.exports = __webpack_public_path__ + "static/media/all-nuggets.9d36a2e7.svg";